import {VuexModule, Module, Action, Mutation, getModule} from 'vuex-module-decorators'
import {getToken, setToken, removeToken} from '@/utils/cookies'
import store from '@/store'
import {wt} from "@/api";

export interface IUserState {
  token: string
  name: string
  avatar: string
  introduction: string
  grantedpermissions:any
  roles: string[]
}

@Module({dynamic: true, store, name: 'user'})
class User extends VuexModule implements IUserState {
  public token = getToken() || ''
  public name = ''
  public avatar = ''
  public introduction = ''
  public grantedpermissions = '';
  public roles: string[] = []

  @Mutation
  private SET_TOKEN(token: string) {
    this.token = token
  }

  @Mutation
  private SET_NAME(name: string) {
    this.name = name
  }

  @Mutation
  private SET_AVATAR(avatar: string) {
    this.avatar = avatar
  }

  @Mutation
  private SET_INTRODUCTION(introduction: string) {
    this.introduction = introduction
  }

  @Mutation
  private SET_GRANTEDPERMISSIONS(grantedpermissions: string) {
    this.grantedpermissions = grantedpermissions
  }

  @Mutation
  private SET_ROLES(roles: string[]) {
    this.roles = roles
  }

  @Action
  public async Login(token: string) {
    setToken(token)
    this.SET_TOKEN(token)
  }

  @Action
  public ResetToken() {
    removeToken()
    this.SET_TOKEN('')
    this.SET_ROLES([])
  }

  @Action
  public async GetUserInfo() {

  }

  @Action
  public async LogOut() {
    removeToken()
    this.SET_TOKEN('')
    this.SET_ROLES([])
  }
}

export const UserModule = getModule(User)
